export interface SessionState {
  duration: number;
  time: string;
}

export const getDefaultSessionState = (): SessionState => {
  return {
    duration: 0,
    time: '00:00',
  };
};